import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import debounce from 'lodash.debounce';

const styles = {
  multiValue: (base, _state) => ({ ...base, backgroundColor: '#E0EAEC' }),
  multiValueLabel: (base, _state) => ({ ...base, fontWeight: 'bold', fontSize: '16px' }),
  control: (base, _state) => ({
    ...base,
    height: '54px',
    'minHeight': '54px'
  }),
  valueContainer: (base, _state) => ({
    ...base,
    height: '100%'
  })
};

// The avatar comes drawn by the server (SearchController#users), which keeps
// avataaars out of the common pack this component is in.
const formatOptionLabel = ({ value, label, avatarSvg, role }) => (
  <div className="flex items-center justify-start text-left" key={value}>
    <span
      className="inline-block align-center h-10 w-10 mx-auto rounded-full bg-grey-light overflow-hidden shadow-sm mr-4 ml-0"
      dangerouslySetInnerHTML={{ __html: avatarSvg }}
    />
    <span>{label}</span>
    { role == "admin" && (<span className="text-grey"> {"("}<span className="text-info font-semibold">admin</span>{")"}</span>) }
    { role == "creator" && (<span className="text-grey"> {"("}<span className="text-success font-semibold">créateur</span>{")"}</span>) }
    { role == "support" && (<span className="text-grey"> {"("}<span className="text-danger font-semibold">support</span>{")"}</span>) }
  </div>
);

class UserInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      inputValue: ""
    };

    this.onChange = this.onChange.bind(this);
    this.loadOptions = debounce(this.loadOptions.bind(this), 300);
  }

  onChange (type, option) {
    this.setState(prevState => {
      prevState[type] = option;
      return prevState;
    });
  }

  loadOptions (inputValue, callback) {
    fetch(`${this.props.endpoint}?q=${inputValue}`)
      .then(response => response.json())
      .then(data =>
        callback(
          data.filter(user => user.id !== gon.users.id).map(user =>
            (
              {
                value: user.id,
                label: user.name,
                avatarSvg: user.avatar_svg,
                role: user.role
              }
            )
          )
        )
      );
  }

  render() {
    return (
      <div>
        <AsyncSelect
          styles={styles}
          isClearable
          className="w-full"
          placeholder="Choisir"
          loadOptions={this.loadOptions}
          name={this.props.input_name}
          value={this.state.value}
          onChange={value => this.onChange('value', value)}
          formatOptionLabel={formatOptionLabel}
          noOptionsMessage={() => null}
        />
      </div>
    );
  }
}

UserInput.propTypes = {
  input_name: PropTypes.string,
  value: PropTypes.shape({})
};

UserInput.defaultProps = {
  value: []
};

export default UserInput;
